<div
	class="h-full w-full overflow-auto cursor-pointer"
	[innerText]="subtitle()"
	(click)="copyToClipboard()"
	title="Click to copy subtitle to clipboard"
></div>
